import PropTypes from "prop-types";
import { Box, Divider, Drawer } from "@mui/material";
import { LogoSideNav } from "../../../components/logo";
import { Scrollbar } from "../../../components/scrollbar";
import { Link } from "react-router-dom";
import Navigation from "./navigation";

export const SideNav = (props) => {
  const { open, onClose } = props;

  const content = (
    <Scrollbar
      sx={{
        height: "100%",
        "& .simplebar-content": {
          height: "100%",
        },
        "& .simplebar-scrollbar:before": {
          background: "neutral.400",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box sx={{ px: 3, pt: 2, textAlign: "center" }}>
          <Box
            sx={{
              display: "inline-flex",

              // height: 48,
            }}
          >
            <Link to="/">
              <LogoSideNav />
            </Link>

            {/* <Typography
              level="h2"
              fontSize="xl"
              sx={{
                fontFamily: "monospace",
                ml: 1,
                alignSelf: "center",
                color: theme.palette.primary.main,
                fontWeight: 700,
              }}
            >
              Convio
            </Typography> */}
          </Box>
        </Box>
        <Divider sx={{ borderColor: "neutral.700" }} />
        <Navigation />
        <Divider sx={{ borderColor: "neutral.700" }} />
      </Box>
    </Scrollbar>
  );

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "neutral.800",
          color: "common.white",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

SideNav.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
